import { Routes } from '@angular/router';

import { environment } from '../environments/environment';

export const routes: Routes = [
  {
    path: '',
    redirectTo: `/${environment.defaultLang}/home`,
    pathMatch: 'full',
  },
  {
    path: 'adminLoginAsMember',
    loadComponent: () => import('./pages/admin-login-as-member/admin-login-as-member.page').then((m) => m.AdminLoginAsMemberPage),
  },
  {
    path: '',
    loadChildren: () => import('./tabs/tabs.routes').then((m) => m.routes),
  },
  {
    path: '**',
    redirectTo: `/${environment.defaultLang}/home`,
    pathMatch: 'full',
  },
];
